<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="search-panel">
        <button class="btn btn-primary" @click="searchPartner">Search</button>
        <input
          class="form-control"
          type="text"
          placeholder="Phone Number"
          v-model="mobileNumber"
        />
      </div>
    </div>
  </div>
  <div class="table-holder table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>User Code</th>
          <th>Name</th>
          <th>Phone</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="partner in partnerList" :key="partner.user_code">
          <td>{{ partner.user_code }}</td>
          <td>{{ partner.name }}</td>
          <td>{{ partner.mobile }}</td>
          <td>
            <button
              class="btn btn-sm btn-success"
              @click="assignPartnerToTrip(partner.user_code)"
            >
              Assign
            </button>
          </td>
        </tr>
        <tr v-if="partnerList.length <= 0 && !isSearched">
          <td colspan="50" class="text-center">
            Please input 10 or 11 digit phone number to search your desired
            Shuttle Partner.
          </td>
        </tr>
        <tr v-if="partnerList.length <= 0 && isSearched">
          <td colspan="50" class="text-center">
            <span class="text-danger"
              >No user found with the given phone number.</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import http from '../../config/axios';
import userService from '../../config/axiosUserService';

export default {
  props: ['tripRequestId'],
  data() {
    return {
      mobileNumber: '',
      partnerList: [],
      isSearched: false
    };
  },
  watch: {
    mobileNumber: function () {
      if (this.mobileNumber.length != 11) {
        this.isSearched = false;
      }
    }
  },
  methods: {
    containsAnyLetters(str) {
      return /[a-zA-Z]/.test(str);
    },
    hasWhiteSpace(s) {
      return s.indexOf(' ') >= 0;
    },
    searchPartner() {
      this.partnerList = [];
      if (
        this.containsAnyLetters(this.mobileNumber) ||
        this.hasWhiteSpace(this.mobileNumber)
      ) {
        this.$swal({
          icon: 'warning',
          title: 'Please enter a valid phone number!'
        });
      } else if (
        this.mobileNumber &&
        (this.mobileNumber.length == 10 || this.mobileNumber.length == 11)
      ) {
        let url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${this.mobileNumber}`;
        userService
          .get(url)
          .then((response) => {
            this.partnerList = response.data.data;
            this.isSearched = true;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$swal({
          icon: 'warning',
          title: 'Phone number should must be 10 or 11 digit!'
        });
      }
    },
    assignPartnerToTrip(userCode) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are assigning this partner to the trip!',
        icon: 'warning',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          http
            .post(`v2/partners/triprequests/directly-assigned-partner`, {
              partner_trip_request_id: this.tripRequestId,
              directly_assigned_user_code: userCode
            })
            .then((response) => {
              if (response.status == 200) {
                this.mobileNumber = '';
                this.partnerList = [];
                this.$emit('refreshInvitedPartners');
                this.$swal({
                  icon: 'success',
                  title: 'Partner Assigned Successfully!'
                });
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'Something went wrong!'
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                icon: 'error',
                title: 'Something went wrong!'
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.search-panel button {
  float: right;
}
.search-panel input {
  float: right;
  width: 40%;
  margin-right: 20px;
}
.table-holder {
  margin-top: 20px;
}
</style>
